//Dependency getMapUnit
export const getDenormalisedMapObjects = (store, getters) => (mapId, type = []) => {
    const objects = store.objects.filter( o => o.map_id === mapId && (!type.length || type.includes(o.type)))
    return getters.denormaliseMapObjects(objects)
}
export const getBuilding2GroupRelations = (store, getters) =>
    store.objects.reduce(
        (acc, o) =>
        {
            if( o.type === 'building' )
                acc[getters.t(o,'building_index')] = getters.t(o,'building_group_id');
            return acc
        },{}
    );
export const getUnitsFloors = (store, getters) => {
    return !_.isEmpty(store.unitsFloors) ?
        store.unitsFloors :
        store.units.reduce( (acc, unit) => {
            let floorObject, floorObjectMeta, floorUnit;
            if(unit.floor_id){
                floorObject = getters.getMapObjectById(unit.floor_id)
                floorObjectMeta = getObjectProp(floorObject,'meta',{}, ['icons'])
                floorUnit = getters.getUnit(floorObject.units[0])
            }
            else{
                floorUnit = getters.getUnitFloor(unit)
                if(!floorUnit)
                {
                    //console.error(`Can't find floor of the ${unit.name}, unit will be skipped`)
                    return acc
                }
                floorObject = getters.getUnitObjects(floorUnit, 'floor').pop()
                floorObjectMeta = getObjectProp(floorObject,'meta',{}, ['icons'])
            }

            acc[unit.id] = {
                id: floorObject.id,
                level: floorObjectMeta.level,
                building_index: floorObjectMeta.building_index,
                meta: floorObjectMeta,
                unit_name: floorUnit.name,
                unit: floorUnit,
            }
            return acc
        }, {})
}

function getObjectProp (obj, prop, def = {}, exclude = [] ){
    if(!obj) return def;
    const result =  { ...obj[prop], ..._.get(obj, `versions[0].${prop}`, def) }
    exclude.forEach( e => delete result[e])
    return result
}

export const denormaliseMapObjects = (store, getters) => (objects) => {
    const result = [];

    objects.forEach((obj) => {
        obj.units.forEach((uid) => {
            const unit = getters.getUnit(uid)

            const denormalisedObject =
            {
                id: obj.id,
                type: obj.type,
                meta: getObjectProp(obj,'meta',{}, [/*'icons'*/]),
                files: getObjectProp(obj,'files',{}, []),
                lists: getObjectProp(obj,'lists',{}, []),
                unit: {
                    id: unit.id,
                    name: unit.name,
                    map_model_id: unit.map_model_id
                },
                floor: getters.getUnitsFloors[uid]

                // created_at: obj.created_at,
                // updated_at: obj.updated_at,
            }
            // set building group ID
            // denormalisedObject.floor.floor_key = (denormalisedObject.floor.meta.name_en ||  '1 NONE').split(' ')[1]
            denormalisedObject.floor.building_group_id = getters.getBuilding2GroupRelations[denormalisedObject.floor.building_index]

            result.push(denormalisedObject)
        })
    })
    return result
}

export const getDenormalisedMapUnits = (store, getters) => (mapId, type = []) => {
    const units = store.units.filter( u => u.map_id === mapId && (!type.length || type.includes(u.type)))
    return getters.denormaliseMapUnits(units)
}
export const denormaliseMapUnits = (store, getters) => (units) => {
    return units.map((unit) => {

        return {
            ...unit,
            floor: getters.getUnitsFloors[unit.id]
        }
    })
}

// -------------------------------------------- Units ----------------------------------------------------
export const getUnit = ({units}) => (unitIdOrName) => units.find((u) => u.id === unitIdOrName || u.name === unitIdOrName);
export const getUnitFloor = ({ objects, units }, getters) => (u) => {
    // Could be UnitID or UnitName or object
    const unit = u && u.id ? u : getters.getUnit(u)
    if(!unit || !unit.id ) return
    if ( getters.getUnitObjects(unit.id,'floor').length )
        return unit
    if (!unit.parent_id) return null
    return getters.getUnitFloor(unit.parent_id)
}
export const getUnitObjects = ({objects}, getters) => (u, types = []) => {
    const unit = u && u.id ? u : getters.getUnit(u)
    if(!unit){
        console.error(`Can't find unit ${u}`)
        return [];
    }
    const typesArray = Array.isArray(types) ? types : [types]
    return objects.filter(
        (obj) => obj.units.includes(unit.id) && (!typesArray.length || typesArray.includes(obj.type) )
    )
}
export const getMapObjectById = ({objects}) => (oid) => objects.find((obj) => obj.id === oid);
